var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIcon = function SvgIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 40,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.138.138H2.172C1.258.138.517.879.517 1.793c0 6.399 5.188 11.586 11.586 11.586h3.31v6.803a11.549 11.549 0 0 0-8.275-3.492H2.172c-.914 0-1.655.74-1.655 1.655 0 6.399 5.188 11.586 11.586 11.586h3.31v6.62H2.174a1.655 1.655 0 0 0 0 3.311h29.793a1.655 1.655 0 0 0 0-3.31H18.724V21.655h3.31c6.4 0 11.587-5.187 11.587-11.586 0-.914-.741-1.655-1.655-1.655H27c-3.117 0-6.102 1.259-8.276 3.492v-.182C18.724 5.325 13.537.138 7.138.138zm4.965 9.931a8.276 8.276 0 0 1-8.11-6.62h3.145a8.276 8.276 0 0 1 8.11 6.62h-3.145zm0 16.552A8.276 8.276 0 0 1 3.993 20h3.145a8.276 8.276 0 0 1 8.11 6.62h-3.145zM27 11.724h3.145a8.276 8.276 0 0 1-8.11 6.62H18.89a8.276 8.276 0 0 1 8.11-6.62z",
    fill: "#777776",
    fillRule: "nonzero"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon.d37b0f78.svg";
export { ForwardRef as ReactComponent };